import React, { useState, useEffect } from "react";

function Pancakes() {

    const [Pancakes, setPancakes] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'NALEŚNIKI');

            if (category) {
                setPancakes(category.menu_items);
            };
        });
    }, []);

    return(

        <div className="container-fluid">
            <div className="container pb-5">
            <p className="menu-item-title-font fs-1 fw-bold pt-5">NALEŚNIKI</p>
            <hr/>
            {Pancakes.map((pancake) => (
                <div key={pancake.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{pancake.name}</p>
                        <p className="fs-5 no-wrap m-0">{pancake.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{pancake.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
        </div>
        </div>
    )
}

export default Pancakes;